// extracted by mini-css-extract-plugin
module.exports = {"item":"MetaDataItem_item__3u-bu","value":"MetaDataItem_value__1lpRV","title":"MetaDataItem_title__ujw35"};